import { yupResolver } from '@hookform/resolvers';
import { CopyRight } from '@ifca-root/react-component/src/components/AuthLayout/CopyRight';
import { CommonDialog } from '@ifca-root/react-component/src/components/Dialog/CommonDialog';
import { ErrorDialog } from '@ifca-root/react-component/src/components/Dialog/ErrorDialog';
import Loading from '@ifca-root/react-component/src/components/Loading/Loading';
import SnackBarMsg from '@ifca-root/react-component/src/components/SnackBar/SnackBarMsg';
import { contractEnvVar } from '@ifca-root/react-component/src/helpers/Global/EnvironmentVar';
import { SITE_VERSION } from '@ifca-root/react-component/src/helpers/Global/ContractVersion';
import {
  Button,
  Checkbox,
  FormControlLabel,
  Grid,
  IconButton,
  InputAdornment,
  TextField,
} from '@material-ui/core';
import { Visibility, VisibilityOff } from '@material-ui/icons';
import { setAccessToken } from 'AccessToken';
import { ContractClient } from 'SiteClient';
import Background from 'assets/images/HR-Background.jpg';
import Logo from 'assets/images/sitex-logo.png';
import { AuthLayout } from 'components/AuthLayout/AuthLayout';
import SnackBarContext from 'containers/App/Store/SnackBarContext';
import {
  LoggedInUserProfileDocument,
  LoggedInUserProfileQuery,
  useLoginMutation,
  useVerifySiteLazyQuery,
} from 'generated/graphql';
import { encryptMessage } from 'helpers/Crypto/JSEncrypt';
import { LoginSchema } from 'helpers/YupSchema/formSchema';
import React, { useContext, useEffect, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { useHistory } from 'react-router';
import { useLocation } from 'react-router-dom';
import { smallTitle } from '@ifca-root/react-component/src/helpers/Global/ContractGlobalVar';

interface ILoginForm {
  email: string;
  password: string;
  showPassword: boolean;
  rememberMe: boolean;
  product: string;
}
export const Login = props => {
  let history = useHistory();
  const rememberme: any = localStorage.getItem('rememberme');
  const errState = useLocation();
  const { setSnackBarMsg, setOpenSnackBar }: any = useContext(
    SnackBarContext as any,
  );
  localStorage.clear();
  if (rememberme !== null) {
    localStorage.setItem('rememberme', rememberme);
  }

  if (!!errState?.state) {
    errState.state = null;
    setSnackBarMsg(
      'Session has Expired/Not Authenticated! Please relogin again',
    );
    setOpenSnackBar(true);
  }

  const [errorDialog, setErrorDialog] = useState(false);
  const [errorMsg, setErrorMsg] = useState('');

  // DECLARE TITLE HEADER
  useEffect(() => {
    document.title = `${smallTitle.PRODUCT_CODE} Site Mgmt ${contractEnvVar()}`;
  }, []);

  const [
    verifyingSite,
    {
      loading: verifyLoading,
      error: verifyError,
      data: { verifySite } = { verifySite: '' },
    },
  ] = useVerifySiteLazyQuery({
    fetchPolicy: 'network-only',
    onError: e => {
      let error = e.message.substring(15);
      setErrorDialog(true);
      setErrorMsg(error);
    },
    onCompleted: ({ verifySite }) => {
      localStorage.setItem('siteID', verifySite);
      history.push(!!verifySite ? `/home/${verifySite}` : `/home`);
    },
  });

  const [loginAccount, { loading, error, data: { login } = { login: {} } }] =
    useLoginMutation({
      onError: error => {
        error.graphQLErrors.map(({ message }) => {
          console.log('ERROR', message);
          setMessage(message);
          setOpenAlert(true);
        });
      },
      update: (store, { data }) => {
        if (!data) return null;
        store.writeQuery<LoggedInUserProfileQuery>({
          query: LoggedInUserProfileDocument,
          data: {
            __typename: 'Query',
            loggedInUserProfile: data.login.user as any,
          },
        });
      },
      onCompleted: ({ login }) => {
        if (login && login?.accessToken) {
          setAccessToken(login?.accessToken);
          sessionStorage.setItem('accessToken', login?.accessToken);
        }
        if (login?.user?.lastestAccessedEntity) {
          localStorage.setItem(
            'latestSite',
            login?.user?.lastestAccessedEntity,
          );
        }
        if (rememberMe) {
          let rememberme = {
            username: getValues('email'),
            password: getValues('password'),
          };
          localStorage.setItem('rememberme', JSON.stringify(rememberme));
        } else localStorage.removeItem('rememberme');

        verifyingSite({
          variables: {
            accountID: login?.user?.accountID,
            siteID: login?.user?.lastestAccessedEntity,
          },
        });
      },
      client: ContractClient as any,
    });

  // USE LAZY QUERY TO VERIFY THE user?.lastestAccessedEntity
  // From the onCompleted: Check if it exist
  // If exist then use history.push(`/lastestAccessedEntity`)
  // Else just grab any latest site to history.push

  const [rememberMe, setRememberMe] = useState(
    rememberme !== null ? true : false,
  );

  const [values, setValues] = useState(false);
  const [open, setOpen] = useState(false);
  const [openAlert, setOpenAlert] = useState(false);
  const [message, setMessage] = useState('');

  const handleCloseAlert = () => {
    setOpenAlert(false);
  };

  const handleCloseSnackBar = () => {
    setOpen(false);
    history.push('/profile');
  };
  const MESSAGE = 'Password Changed Successfully';

  const handleClickShowPassword = () => {
    setValues(!values);
  };

  const handleMouseDownPassword = event => {
    event.preventDefault();
  };
  const handleCheckRememberMe = (checked: boolean) => {
    setRememberMe(checked);
  };

  //useForm set DefaultValues, validationSchema
  const { handleSubmit, register, errors, control, getValues, reset } =
    useForm<ILoginForm>({
      defaultValues: {
        email: rememberme !== null ? JSON.parse(rememberme)?.username : '',
        password: rememberme !== null ? JSON.parse(rememberme)?.password : '',
      },

      resolver: yupResolver(LoginSchema),
    });

  // NEW WITH ENCRYPTED MESSAGE FOR PASSWORD
  const onSubmit = data => {
    loginAccount({
      variables: {
        loginId: data?.email,
        password: encryptMessage(data?.password),
        siteAccess: true,
      },
    });
  };

  return (
    <>
      {loading && <Loading />}
      {verifyLoading && <Loading />}
      <AuthLayout className="margin-override" logo={Logo} image={Background}>
        <div
          className="xsTitle color-primary-orange"
          style={{ textAlignLast: 'center' }}
        >
          {SITE_VERSION}
        </div>
        <form onSubmit={handleSubmit(onSubmit)} id="submit-form">
          <div className="form-box">
            <Controller
              as={TextField}
              fullWidth
              helperText={errors?.email?.message}
              error={errors?.email ? true : false}
              autoComplete="off"
              name="email"
              label="Email/Username"
              control={control}
              data-qa="usernameInput"
            />
            <Grid container justify="flex-start">
              <Controller
                as={TextField}
                fullWidth
                helperText={errors?.password?.message}
                error={errors?.password ? true : false}
                autoComplete="off"
                name="password"
                label="Password "
                type={values ? 'text' : 'password'}
                value={getValues('password')}
                //   onChange={handleChange('password')}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="Password"
                        onClick={handleClickShowPassword}
                        onMouseDown={handleMouseDownPassword}
                      >
                        {values ? <Visibility /> : <VisibilityOff />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                control={control}
                data-qa="passwordInput"
              />
            </Grid>

            <div className="other-auth">
              <FormControlLabel
                control={
                  <Checkbox
                    name="checkedB"
                    color="primary"
                    checked={rememberMe}
                    onChange={e => handleCheckRememberMe(e.target.checked)}
                  />
                }
                label="Remember Me"
              />
              <span
                className="forget-link"
                onClick={() => history.push('/forgot-password')}
                data-qa="forgotPasswordLink"
              >
                Forgot Password?
              </span>
            </div>

            <Button
              type="submit"
              variant="contained"
              color="primary"
              className="login-btn"
              data-qa="loginButton"
            >
              Login
            </Button>
          </div>
        </form>

        <CommonDialog
          fullWidth={true}
          open={openAlert}
          onClose={handleCloseAlert}
          sections={{
            header: { title: 'Login Error' },
            body: () => <div>{message}</div>,
            footer: {
              actions: [
                {
                  displayText: 'Ok',
                  props: {
                    onClick: () => handleCloseAlert(),
                    variant: 'contained',
                    color: 'primary',
                  },
                },
              ],
            },
          }}
        />
        <SnackBarMsg
          open={open}
          message={MESSAGE}
          onClose={handleCloseSnackBar}
        />

        <ErrorDialog
          errorDia={errorDialog}
          setErrorDia={setErrorDialog}
          errorMsg={errorMsg}
          errorHeaderMsg="Login Verification Error"
        />
      </AuthLayout>
      <CopyRight />
    </>
  );
};
